<template>
  <div>
      <!-- <h1>HELLO</h1>
      <h1>{{user}}</h1>

      <h1>role:{{role}}</h1> -->
  </div>
</template>

<script>
export default {
  name: 'Level',

  data() {
    return {
      user: 'user',
      role: 'role',
    };
  },
  beforeMount() {
    this.user = this.$store.state.user.name;
    this.role = this.$store.state.user.role;
    // console.log('ROLE: ' + this.role);

    if (this.role == '6af978f0-96ed-11e8-bb38-37f5ae311cf6') {
      // console.log('MATCH');
      this.$router.push({ name: 'Timeline' });
    }
  },
};
</script>

<style>
</style>